import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';
import  dataurl from '../../assets/config.json';


  

@Injectable()
export class FrontOffService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
         
           this.callurl=_global.baseAPIUrl;
         }

            getsysdatetoday()
   {
    return this.http.get(this.callurl + 'getsysdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }

         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=9)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }
         getstudents(oprtype,stuid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selstutstudent',{clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,stuid:stuid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

           getstudents_reg(oprtype,stuid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selstutstudent_reg',{clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,stuid:stuid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          getenquiries(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selenquiry/db/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.enquiry;
                    
                }));
          }

          masbloodgroups(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'masbloodgroup/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masbloodgroup;
                    
                }));
          }

          mascastecat(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'mascastecat/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.mascastecat;
                    
                }));
          }
          masacademicyear(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'masacademicyear/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masacademicyear;
                    
                }));
          }
          massubcomb(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_exmsubcomb/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('sel_sp_exmsubcomb', data);
                    return data.sp_exmsubcomb;
                    
                }));
          }

          getinstite(): Observable<any> {

            var enqpost={clcd:this.clcd,aycd:this.aycd};
                
            //this.callurl='https://mycampuz.co.in/schoolpayment/admclasslist.php'
            
          
            // this.callurl=this.baseUrl+'Payenqrequest'
             return this.http.get(  this.callurl +"getmasinstitute/"+this.clcd+"/"+this.aycd )
                 .pipe(map((data: any) => 
                 {
                     console.log('clases',data);
                     return  data.masinstitute ; 
                 }));
          } 

          mashouse(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_mashouse/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_mashouse;
                    
                }));
          }

          mascourse(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getmascourse/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.mascourse;
                    
                }));
          }

          maspayopt(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accpayoptions/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accpayoptions;
                    
                }));
          }

          masfeequota(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accfeequota/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accfeequota;
                    
                }));
          }

          masmot(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masmot/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masmot;
                    
                }));
          }
          massection(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_massection/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massection;
                    
                }));
          }

          masclass(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masclass/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masclass;
                    
                }));
          }
          
          getdashconts(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'admissioninfocounts/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('admissioninfocounts', data);
                    return data.admissioninfocounts;
                    
                }));
          }
          save_admission(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.crby=this.usid;
            return this.http.post(this.callurl + 'savestutstudent', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }


        save_admission_reg(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.crby=this.usid;
            return this.http.post(this.callurl + 'savestutstudent_reg', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }

        savetcdetails(admdata: any): Observable<any> {

          debugger
          admdata.clcd=this.clcd;
          admdata.aycd=this.aycd;
          admdata.crby=this.usid;
          return this.http.post(this.callurl + 'savetcdetails', admdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

        save_enquiry(admdata: any): Observable<any> {

          debugger
          admdata.clcd=this.clcd;
          admdata.aycd=this.aycd;
          admdata.crby=this.usid;
          console.log(admdata);
          return this.http.post(this.callurl + 'enquiry', admdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

      save_stutenquiry(admdata: any): Observable<any> {

        debugger
        admdata.clcd=this.clcd;
        admdata.aycd=this.aycd;
        admdata.usid=this.usid;
        admdata.crby=this.usid;
        console.log(admdata);
        return this.http.post(this.callurl + 'savestutenquiry', admdata)
            .pipe(map((data: any) => {
                console.log('retres', 'response');
                return data
            }));
    }

    getstutenquiry(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'selstutenquiry/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.enquiry;
              
          }));
    }

    getenquiryinfocnt(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'enquryinfocount/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.enquiryinfocnt;
              
          }));
    }

    uploadmemberphoto(data: File,bkid,dcid): Observable<any> {
      /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
    debugger
      const formData: FormData = new FormData();
      console.log("stuid",bkid)
      formData.append('Image', data, data.name);
        
        formData.append('memid', bkid);
        formData.append('dcid', dcid);
        formData.append('clcd', this.clcd);
        formData.append('aycd', this.aycd);
        formData.append('crby', this.usid);
        console.log("formData",formData);
       return this.http.post(this._global.baseAPIUrl + 'uploadstudentdoc', formData)
       .pipe(map((data: any) => {
           console.log('retres', data);
           return data
       }));
    }


    getstudentdocs(stuid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getstudentdocs/'+this.clcd+'/'+this.aycd+'/'+stuid)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.studoclst;
              
          }));
    }

    delstudentdocs(rid,dcpath): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      var pst={clcd:this.clcd,aycd:this.aycd,rid:rid,dcpath1:dcpath}
      return this.http.post(this.callurl + 'delstudoc',pst)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }
    getstudent_dbfields(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getstudent_dbfields')
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrfields;
              
          }));
    }
    getstudents_clwise(clid,secid,crid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.post(this.callurl + 'selstudent_clwise',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,crid:crid})
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.stulst;
              
          }));
    }


    getstudentslist(clid,secid,crid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.post(this.callurl + 'selstudents',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,crid:crid})
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.stulst;
              
          }));
    }

    updatestudentbulk(arrdata,dbfield): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.post(this.callurl + 'updatestudentbulk',{clcd:this.clcd,aycd:this.aycd,usid:this.usid,updfield:dbfield,arrstudent:arrdata})
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }

    studentoverview(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'studentoverview/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }

    enqoverview(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'enquiryoverview/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data;
              
          }));
    }


    getcerttypes(): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getcerttypes')
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrcerftypes;
              
          }));
    }


    getcertformat(clid,crid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getcertformat/'+clid+'/'+crid)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrformats;
              
          }));
    }

    getcertformatdet(rid): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');libsubjectgroup
      
      return this.http.get(this.callurl + 'getcertformatdet/'+rid)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.arrformats;
              
          }));
    }


    stuprofile(oprtype,stuid): Observable<any> {
      debugger
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      
      return this.http.get(this.callurl + 'studentprofile/'+clcd+'/'+aycd+'/'+stuid+'/'+oprtype)
      .pipe(map((data: any) => {
              console.log('retres-data', data);
              return data.profdata;
              
          }));
    }

    gethosstudents(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selhosstudent',{clcd:this.clcd,aycd:this.aycd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          getbedsbycat(catid,buid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selbedbycategory',{buid:buid,rmctid:catid,clcd:this.clcd,aycd:this.aycd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          save_allotbed(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'allotbed', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

      getwaleaves(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selwaleaves',{clcd:this.clcd,aycd:this.aycd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          getmenleaves(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selmenleaves',{clcd:this.clcd,aycd:this.aycd,usid:this.usid})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }

          declinleaverequest(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'declinleaverequest', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }

        approveleaverequest(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        secdata.usid=this.usid;
          return this.http.post(this._global.baseAPIUrl + 'approveleaverequest', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }


      birthdaysoftheday(brdt): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'birthdaysoftheday/'+this.clcd+'/'+this.aycd+'/'+brdt)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrstaff;
                    
                }));
          }

selhostelstudent(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.post(this.callurl + 'selhostelstudent',{clcd:this.clcd,aycd:this.aycd})
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.stulst;
                    
                }));
          }

          sel_hosinstitute(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_hosinstitute/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.arrinstute;
                    
                }));
          }

          savehostelstudent(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.crby=this.usid;
            return this.http.post(this.callurl + 'savehostelstudent', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }
          


           getstudentsfromotherinstitute(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.crby=this.usid;
            return this.http.post(this.callurl + 'getstudentsfromotherinstitute', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', data);
                    return data.stulst
                }));
        }

        copystudatatohostel(admdata: any): Observable<any> {

            debugger
            admdata.clcd=this.clcd;
            admdata.aycd=this.aycd;
            admdata.emid=this.usid;
            return this.http.post(this.callurl + 'copystudatatohostel', admdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }
}